import React, { useEffect, useMemo, useRef, useState } from 'react'
import { Modal } from 'react-bootstrap'
import { AddNode, ClearFilter, DeleteIcon, Edit, EditButtonIcon, FilterIcon, InfoIcon1, RemoveIcon, SaveFilter } from '../../../assets/images'
import { useDispatch, useSelector } from 'react-redux'
import { MaterialReactTable } from 'material-react-table'
import EditNoteIcon from '@mui/icons-material/EditNote';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Button, Tooltip, CircularProgress, Box } from '@mui/material'
import { useHistory } from 'react-router-dom';
import SiteAdditionForm from './SiteAdditionForm'
import { MultiSelect } from 'react-multi-select-component'
import AlertTemplateMessage from '../../Configuration/AlertTemplate/AlertTemplateMessage'
import Swal from 'sweetalert2'
import filtersConfig from '../Filters'
import { deletesite, getAllFilters, getAllSiteList } from '../../../services/configurationServices'
import SiteBulkEditForm from './SiteBulkEditForm'

const SiteConfig = ({showSuccessToast}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [showAddSite, setShowAddSite] = useState(false);
  const [showBulkEditModal, setShowBulkEditModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedCustomer, setSelectedCustomer] = useState(null)
  const [showSavedFilterDeleteModal, setShowSavedFilterDeleteModal] = useState(false)
  const [openInfoFilter, setOpenInfoFilter] = useState(false)
  const [modalFilterName, setModalFilterName] = useState("")
  const [selected, setSelected] = useState([]);
  const [editCountryId, setEditCountryId] = useState(null);
  const [rowSelection, setRowSelection] = useState({});
  const wrapperRef = useRef(null);
  const [filterValues, setFilterValues] = useState({});
  const [filterData, setFilterData] = useState(null);
  const [siteData, setSiteData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filtersApplied, setFiltersApplied] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [globalFilter, setGlobalFilter] = useState('');

  // Enhanced configuration with extensible field mappings
  const getPageConfiguration = () => {
    const pageConfig = filtersConfig.find(config => config.pagename === 'SiteConfiguration');
    if (!pageConfig) {
      console.warn('SiteConfiguration not found in filters config');
      return { filters: {}, fieldMapping: {}, displayConfig: {} };
    }
    return pageConfig;
  };

  const pageConfig = getPageConfiguration();
  const pageFilters = pageConfig.filters;
  
  // Dynamic field mapping configuration - can be moved to external config
  const defaultFieldMapping = {
    'Customer': 'ClientName',
    'State': 'statename', 
    'City': 'City',
    'Site': 'SiteName',
    'Zone': 'ZoneName',
    'Interface': 'InterfaceName',
    'Device': 'DeviceName'
  };

  // Use configured field mapping or fall back to default
  const fieldMapping = pageConfig.fieldMapping || defaultFieldMapping;

  // Get the actual field name from configuration (with fallback to default mapping)
  const getFieldName = (filterKey) => {
    const filterConfig = pageFilters[filterKey];
    if (filterConfig && filterConfig.fieldName) {
      return filterConfig.fieldName;
    }
    return fieldMapping[filterKey] || filterKey;
  };

  // Get placeholder text from configuration
  const getPlaceholderText = (filterKey, filterConfig) => {
    if (filterConfig.placeholder) {
      return filterConfig.placeholder;
    }
    return `Select ${filterConfig.label}${filterConfig.mandatory ? '*' : ''}`;
  };
  
  // Excel-like Filter Utility - filters options based on other active selections
  const getFilteredOptions = (filterKey, optionKey, labelKey) => {
    if (!filterData || !filterData.Data) {
      return [];
    }

    // Build a filter object with only selected values for each filter (excluding current filter)
    const activeSelections = {};
    Object.keys(pageFilters).forEach(key => {
      const selected = filterValues[key];
      if (
        key !== filterKey &&
        Array.isArray(selected) &&
        selected.length > 0
      ) {
        // For State filter, we need to use the statemasterid for comparison
        if (key === 'State') {
          activeSelections[key] = selected.map(item => 
            typeof item === "object" ? item.value : item
          );
        } else {
          activeSelections[key] = selected.map(item => 
            typeof item === "object" ? item.value : item
          );
        }
      }
    });

    // Filter data based on all other active selections
    const filtered = filterData.Data.filter(item => {
      return Object.entries(activeSelections).every(([key, selectedVals]) => {
        // Use the correct field for comparison
        let compareField;
        if (key === 'Customer') {
          compareField = 'ClientId';
        } else if (key === 'State') {
          compareField = 'statemasterid';
        } else if (key === 'City') {
          compareField = 'City';
        } else {
          compareField = getFieldName(key);
        }
        return selectedVals.includes(item[compareField]);
      });
    });

    // Get unique options for this filter
    const seen = new Set();
    return filtered
      .filter(item => {
        const val = item[optionKey];
        if (!val || seen.has(val)) return false;
        seen.add(val);
        return true;
      })
      .map(item => ({
        label: item[labelKey],
        value: item[optionKey],
      }))
      .sort((a, b) => {
          // Sort options in ascending order by label
          return a.label.localeCompare(b.label, undefined, { 
              numeric: true, 
              sensitivity: 'base' 
          });
      });
  };

  // Create options from API filterData with Excel-like filtering - now fully dynamic
  const getFilterOptions = (filterKey) => {
    if (!filterData || !filterData.Data) {
      return [];
    }
    
    let optionKey, labelKey;
    
    if (filterKey === 'Customer') {
      // For Customer, use ClientId as value and ClientName as label
      optionKey = 'ClientId';
      labelKey = 'ClientName';
    } else if (filterKey === 'State') {
      // For State, use statemasterid as value and statename as label
      optionKey = 'statemasterid';
      labelKey = 'statename';
    } else if (filterKey === 'City') {
      // For City, use City as both value and label
      optionKey = 'City';
      labelKey = 'City';
    } else {
      const fieldName = getFieldName(filterKey);
      optionKey = fieldName;
      labelKey = fieldName;
    }
    
    return getFilteredOptions(filterKey, optionKey, labelKey);
  };

  const handleFilterChange = (filterKey, value) => {
    console.log("FilterKey", filterKey)
    console.log("FilterKey", value)
    if(filterKey == 'Customer' && value.length > 0) {
      console.log("FilterKey", value)
      setSelectedCustomer(value[0])
    }
    setFilterValues(prev => {
      const newValues = {
        ...prev,
        [filterKey]: value
      };

      // Smart dependency clearing - clear dependent filters when parent changes
      const filterConfig = pageFilters[filterKey];
      if (filterConfig) {
        // Find and clear all dependent filters
        Object.entries(pageFilters).forEach(([key, config]) => {
          if (config.parentFilter === filterKey) {
            newValues[key] = [];
            // Recursively clear dependencies
            const clearDependencies = (parentKey) => {
              Object.entries(pageFilters).forEach(([depKey, depConfig]) => {
                if (depConfig.parentFilter === parentKey) {
                  newValues[depKey] = [];
                  clearDependencies(depKey);
                }
              });
            };
            clearDependencies(key);
          }
        });
      }
      console.log("FilterKey", newValues)
      return newValues;
    });

    // Only reset table state when mandatory filters are changed
    const filterConfig = pageFilters[filterKey];
    if (filterConfig && filterConfig.mandatory) {
      // Reset table state when mandatory filters change
      setSiteData([]);
      setFiltersApplied(false);
      setRowSelection({});
      setPagination({
        pageIndex: 0,
        pageSize: 10,
      });
    }
  };

  // Enhanced validation with better error messaging
  const isMandatoryFiltersMissing = () => {
    return Object.entries(pageFilters).some(([filterKey, filterConfig]) => {
      return filterConfig.mandatory && (!filterValues[filterKey] || filterValues[filterKey].length === 0);
    });
  };

  // Get missing mandatory filters for better user feedback
  const getMissingMandatoryFilters = () => {
    return Object.entries(pageFilters)
      .filter(([filterKey, filterConfig]) => {
        return filterConfig.mandatory && (!filterValues[filterKey] || filterValues[filterKey].length === 0);
      })
      .map(([filterKey, filterConfig]) => filterConfig.label);
  };

  // Enhanced filter button tooltip
  const getFilterButtonTooltip = () => {
    const missingFilters = getMissingMandatoryFilters();
    if (missingFilters.length > 0) {
      return `Please select: ${missingFilters.join(', ')}`;
    }
    return "Apply Filter";
  };

  // Clear all filters function
  const handleClearAllFilters = () => {
    setFilterValues({});
    setSiteData([]);
    setFiltersApplied(false);
    setRowSelection({});
    setGlobalFilter('');
    setPagination({
      pageIndex: 0,
      pageSize: 10,
    });
  };

  // Handle global filter change with pagination reset
  const handleGlobalFilterChange = (value) => {
    setGlobalFilter(value);
    // Reset to first page whenever search changes
    setPagination(prev => ({
      ...prev,
      pageIndex: 0
    }));
  };

  // Apply filters function - now calls API and stores response
  const handleApplyFilters = async () => {
    if (!isMandatoryFiltersMissing()) {
      setLoading(true);
      setFiltersApplied(true);
      try {
        // Prepare filter parameters from selected values
        const filterParams = {};
        Object.entries(filterValues).forEach(([key, value]) => {
          if (value && value.length > 0) {
            if (key === 'State') {
              // For State, pass the statemasterid (ID value) instead of text
              filterParams['StateID'] = value[0]?.value || value[0];
            } else if (key === 'City') {
              filterParams['City'] = value[0]?.value || value[0];
            } else if (key === 'Customer') {
              // For Customer, pass the ClientId (ID value) instead of text
              filterParams['CustomerID'] = value[0]?.value || value[0];
            } else {
              const fieldName = getFieldName(key);
              filterParams[fieldName] = value[0]?.value || value[0];
            }
          }
        });

        const response = await getAllSiteList(filterParams);
        if (response && response.Data) {
          setSiteData(response.Data);
          console.log("editCountryId", response.Data)
          setEditCountryId(response.Data[0]?.countrymasterid || null);
          console.log('Site data loaded:', response.Data);
        } else {
          setSiteData([]);
          console.warn('No site data received:', response);
        }
      } catch (error) {
        console.error('Error loading sites:', error);
        setSiteData([]);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    // const fetchFilters = async () => {
    //   try {
    //     const response = await getAllFilters({ Entity: 'Site' });
    //     setFilterData(response);
    //     console.log('Site filter data loaded:', response);
    //   } catch (error) {
    //     console.error('Error loading site filters:', error);
    //     setFilterData(null);
    //   }
    // };
    
    fetchFilters();
  }, []);

      const fetchFilters = async () => {
      try {
        const response = await getAllFilters({ Entity: 'Site' });
        setFilterData(response);
        console.log('Site filter data loaded:', response);
      } catch (error) {
        console.error('Error loading site filters:', error);
        setFilterData(null);
      }
    };

  const columns = useMemo(() => {
    // Dynamic columns based on API response
    const dynamicColumns = [];
    
    if (siteData.length > 0) {
      // Get all unique keys from the first few records to determine columns
      const sampleData = siteData.slice(0, 5);
      const allKeys = new Set();
      sampleData.forEach(record => {
        Object.keys(record).forEach(key => allKeys.add(key));
      });

      // Define column mappings for better display names and formatting
      // The order of this object determines the column order in the table
      const columnMappings = {
        'SiteName': { header: 'Site Name', size: 300 },
        'ClientName': { header: 'Customer Name', size: 250 },
        'BranchID': { header: 'Branch ID', size: 200 },
        'countryname': { header: 'Country', size: 180 },
        'statename': { header: 'State', size: 200 },
        'City': { header: 'City', size: 150 },
        'Address': { header: 'Address', size: 380 },
        'PinCode': { header: 'Pin Code', size: 200 },
        'Region': { header: 'Region', size: 200 },
        'Area': { header: 'Area', size: 200 },
        'SiteMode': { header: 'Site Mode', size: 200 },
      };

      // Skip certain fields that shouldn't be displayed as columns
      const excludeKeys = ['ClientId', 'SiteID', 'AddressId', 'ID', 'CustomerID', 'ClientID', 'CreatedDate', 
        'ModifiedDate', 'IsActive', 'countrymasterid', 'statemasterid', 'SiteModeID'];

      // Create columns in the order defined by columnMappings
      Object.keys(columnMappings).forEach(key => {
        // Only add column if the field exists in the data and is not in exclude list
        if (allKeys.has(key) && !excludeKeys.includes(key)) {
          const mapping = columnMappings[key];
          dynamicColumns.push({
            accessorKey: key,
            header: mapping.header,
            size: mapping.size,
            filterVariant: 'text',
          });
        }
      });

      // Add any remaining fields from sampleData that aren't in columnMappings (fallback)
      Array.from(allKeys).forEach(key => {
        if (!excludeKeys.includes(key) && key !== 'actions' && !columnMappings[key]) {
          dynamicColumns.push({
            accessorKey: key,
            header: key.replace(/([A-Z])/g, ' $1').trim(),
            size: 150,
            filterVariant: 'text',
          });
        }
      });
    } 

    // Always add actions column at the end
    dynamicColumns.push({
      accessorKey: "actions",
      header: "Actions",
      enableColumnActions: false,
      enableSorting: false,
      enableColumnOrdering: false,
      Cell: ({ row }) => (
        <div className="ActionBtns">
          <Tooltip title="Edit" placement="bottom">
            <button className="DataAccessEdit borderButton" onClick={() => showSiteForm(row.original)}>
              <EditNoteIcon className="ActionsIcon" />
            </button>
          </Tooltip>

          <Tooltip title="Delete" placement="bottom">
            <button className="DataAccessEdit borderButton"  onClick={e => onDeleteChange(e, row.original)}>
              <DeleteForeverIcon className="ActionsIcon" />
            </button>
          </Tooltip>
        </div>
      ),
      muiTableHeadCellProps: {
        sx: {
          position: "sticky",
          right: 0,
          backgroundColor: "#064dc3",
          borderTopRightRadius : "20px",
          color: "white",
          fontWeight: "bold",
          zIndex: 3,
          textAlign: "center",
        },
      },
      muiTableBodyCellProps: {
        sx: {
          position: "sticky",
          right: 0,
          zIndex: 2,
          textAlign: "center",
        },
      },
    });

    return dynamicColumns;
  }, [siteData]);

  const pagedData = useMemo(() => {
    let filteredData = siteData;
    
    // Apply global filter to complete dataset first
    if (globalFilter) {
      filteredData = siteData.filter(item => 
        Object.values(item).some(value => 
          String(value).toLowerCase().includes(String(globalFilter).toLowerCase())
        )
      );
    }
    
    // Then apply pagination to filtered data
    const start = pagination.pageIndex * pagination.pageSize;
    const end = start + pagination.pageSize;
    return filteredData.slice(start, end);
  }, [siteData, pagination, globalFilter]);

  // Get filtered count for pagination
  const filteredCount = useMemo(() => {
    if (!globalFilter) return siteData.length;
    
    return siteData.filter(item => 
      Object.values(item).some(value => 
        String(value).toLowerCase().includes(String(globalFilter).toLowerCase())
      )
    ).length;
  }, [siteData, globalFilter]);


  const showSiteForm = (data) => {
    // history.push('/configuration/addsite');
    setShowAddSite(true);
    setSelectedRow(data)
  }

  // Get selected site IDs from row selection
  const getSelectedSiteIds = () => {
    const selectedSiteIds = Object.keys(rowSelection).filter(key => rowSelection[key]);
    console.log('Selected Site IDs:', selectedSiteIds);
    return selectedSiteIds;
  };

  const onBulkEditSites = () => {
    const selectedIds = getSelectedSiteIds();
    if (selectedIds.length === 0) {
      Swal.fire({
        title: "No Selection",
        text: "Please select at least one site to edit.",
        icon: "warning",
      });
      return;
    }
    console.log('Opening bulk edit for site IDs:', selectedIds);
    setShowBulkEditModal(true);
  };

  const onBulkDeleteSite = (e) => {
    e.stopPropagation()
    Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete the selected sites?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#027aaa",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Delete!"
    }).then((result) => {
      if (result.isConfirmed) {

      }
    })
  }

  function onDeleteChange(e, row) {    
    e.stopPropagation();
    Swal.fire({
      title: "Are you sure?",
      text: `You really want to delete "${row.SiteName}" site!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
         deleteSite(row.SiteID);
      }
    });
  }
   const deleteSite = async (siteid) => {
      let userId = localStorage.getItem("UserID");
      await deletesite(userId, siteid).then((resp) => {
        if (resp.Status == "success") {
          showSuccessToast(resp.Message);
          handleApplyFilters();
          fetchFilters();
          return;
        } else if (resp.Status == "failed") {
          Swal.fire({ text: resp.Message });
        } else {
          Swal.fire({ text: "Something went wrong, please try again later!" });
        }
      });
    };

  useEffect(() => {
    if (wrapperRef.current) {
      const labelEl = wrapperRef.current.querySelector(
        ".dropdown-heading .dropdown-heading-value"
      );
      if (labelEl) {
        // Get the first filter with a selection for tooltip
        const filtersWithSelections = Object.entries(filterValues).filter(([key, value]) => 
          Array.isArray(value) && value.length > 0
        );
        
        if (filtersWithSelections.length > 0) {
          const [firstKey, firstValue] = filtersWithSelections[0];
          const selectedLabel = firstValue[0]?.label || "";
          const isTruncated = labelEl.scrollWidth > labelEl.clientWidth;
          labelEl.setAttribute("title", isTruncated ? selectedLabel : "");
        } else {
          labelEl.removeAttribute("title");
        }
      }
    }
  }, [filterValues]);
  

  // Debug logging for filter changes
  useEffect(() => {
    console.log('Filter values updated:', filterValues);
    console.log('Available filters config:', pageFilters);
  }, [filterValues, pageFilters]);

  // Generate filter summary for display
  const getFilterSummary = () => {
    const activeFilters = Object.entries(filterValues)
      .filter(([key, value]) => Array.isArray(value) && value.length > 0)
      .map(([key, value]) => {
        const filterConfig = pageFilters[key];
        const filterLabel = filterConfig?.label || key;
        const valueLabels = value.map(item => item.label || item).join(', ');
        return `${filterLabel}: ${valueLabels}`;
      });
    
    return activeFilters.length > 0 ? activeFilters.join(' | ') : 'No filters applied';
  };


  return (
    <>
      <div className='p-3'>
        {showAddSite ? (
          <SiteAdditionForm showAddSite={showAddSite} setShowAddSite={setShowAddSite} selectedRow={selectedRow} selectedCustomer={selectedCustomer} handleApplyFilters={handleApplyFilters} fetchFilters={fetchFilters} />
        ) : (
          <div className="SiteMainContainer SiteTableMainDiv">
            <div className="DashboardFilterMainDiv">
              <div className="RefreshText" style={{ display: "flex" }}>
                {Object.entries(pageFilters)
                  .sort(([, a], [, b]) => a.sequence - b.sequence)
                  .map(([filterKey, filterConfig]) => (
                    <div key={filterKey} className="inputTypeLabelContainer">
                      <label className="formFieldLabels">
                        {filterConfig.label}
                        {filterConfig.mandatory && <span style={{ color: 'red' }}>*</span>}
                      </label>
                      <div ref={wrapperRef}>
                        <MultiSelect
                          key={filterValues[filterKey]?.[0]?.value}
                          options={getFilterOptions(filterKey)}
                          value={filterValues[filterKey] || []}
                          onChange={(value) => handleFilterChange(filterKey, value.length > 1 ? [value[value.length - 1]] : value)}
                          labelledBy={`Select ${filterConfig.label}`}
                          hasSelectAll={false}
                          isCreatable={false}
                          disableSearch={false}
                          className="SiteConfigSingleSelectDropdownContainer"
                          overrideStrings={{
                              selectSomeItems:
                              (filterValues[filterKey] && filterValues[filterKey][0] && filterValues[filterKey][0].label)
                                  ? filterValues[filterKey][0].label
                                  : getPlaceholderText(filterKey, filterConfig),
                              allItemsAreSelected:
                              (filterValues[filterKey] && filterValues[filterKey][0] && filterValues[filterKey][0].label)
                                  ? filterValues[filterKey][0].label
                                  : getPlaceholderText(filterKey, filterConfig),
                          }}
                        />
                      </div>
                    </div>
                  ))}
                <div className="HMFilterDiv">
                  <Tooltip title={getFilterButtonTooltip()} placement="bottom">
                    <button 
                      className="IconsButtonDiv" 
                      name="filterBtn"
                      disabled={isMandatoryFiltersMissing() || loading}
                      style={{ 
                        opacity: (isMandatoryFiltersMissing() || loading) ? 0.5 : 1,
                        cursor: (isMandatoryFiltersMissing() || loading) ? 'not-allowed' : 'pointer'
                      }}
                      onClick={handleApplyFilters}
                    >
                      <img
                        src={FilterIcon}
                        className="camera-icon-height"
                        alt="Apply filter icon"
                      />
                    </button>
                  </Tooltip>
                  <Tooltip title="Clear Filter" placement="bottom">
                    <button 
                      className="IconsButtonDiv" 
                      name="clearFilterBtn"
                      disabled={loading}
                      style={{ 
                        opacity: loading ? 0.5 : 1,
                        cursor: loading ? 'not-allowed' : 'pointer'
                      }}
                      onClick={handleClearAllFilters}
                    >
                      <img
                        src={ClearFilter}
                        className="camera-icon-height"
                        alt="Clear filter icon"
                      />
                    </button>
                  </Tooltip>
                </div>
              </div>
            </div>
            <div className="SiteMainHeightDiv">
              <div className="col-lg-12 m-0 TabulerReportMainDiv MatReactTableDiv" style={{ height: "calc(100vh - 290px)" }}>
                <div className="card-body p-0">
                  {loading ? (
                    <Box 
                      display="flex" 
                      justifyContent="center" 
                      alignItems="center" 
                      minHeight="400px"
                      flexDirection="column"
                    >
                      <CircularProgress size={60} thickness={4} />
                      <Box mt={2}>
                        <span style={{ fontSize: '16px', color: '#666' }}>Loading site data...</span>
                      </Box>
                    </Box>
                  ) : siteData.length === 0 ? (
                    <div style={{ width: "100%", padding: "20px", textAlign: "center" }}>
                      <AlertTemplateMessage
                        message={
                          !filtersApplied || isMandatoryFiltersMissing()
                            ? "Please select mandatory filters and click Apply Filter to load site data."
                            : "No sites found for the selected filters."
                        }
                      />
                    </div>
                  ) : (
                    <MaterialReactTable
                      columns={columns}
                      data={pagedData}
                      enableGlobalFilter={true}
                      enableColumnFilters={false}
                      enableStickyHeader
                      enableColumnResizing={true}
                      globalFilterFn="contains"
                      columnResizeMode="onEnd"
                      enableColumnOrdering={true}
                      enableRowSelection={true}
                      muiTableHeadCellProps={{
                        className: "myHeaderSelectAll",
                      }}
                      enableHiding={true}
                      displayColumnDefOptions={{
                        'mrt-row-select': { 
                          visibleInShowHideMenu: false,
                          muiTableHeadCellProps: {
                            sx: {
                              position: "sticky",
                              left: 0,
                              backgroundColor: "#0b70d1",
                              borderTopLeftRadius : "20px",
                              color: "white",
                              fontWeight: "bold",
                              zIndex: 5,
                            },
                          },
                          muiTableBodyCellProps: {
                            sx: {
                              position: "sticky",
                              left: 0,
                              backgroundColor: "inherit",
                              zIndex: 4,
                            },
                          },
                        },
                      }}
                      initialState={{ showColumnFilters: false }}
                      manualPagination={true}
                      manualFiltering={true}
                      rowCount={filteredCount}
                      getRowId={(row) => row.SiteID }
                      state={{
                        pagination: pagination,
                        rowSelection: rowSelection,
                        globalFilter: globalFilter,
                      }}
                      onRowSelectionChange={setRowSelection}
                      onPaginationChange={setPagination}
                      onGlobalFilterChange={handleGlobalFilterChange}
                      muiTableContainerProps={{
                        className: "MaterialTableJs myTableContainer",
                        sx: {
                          maxHeight: "100%",
                          overflow: "auto",
                        },
                      }}
                      muiTableHeadProps={{
                        className: "myHeader",
                        sx: {
                          display: "table-header-group",
                        },
                      }}
                      renderTopToolbarCustomActions={({ table }) => (
                        <div className='d-flex justify-content-center align-items-center'>
                          <h4 style={{ margin: 0 }}>
                            List of sites {siteData.length > 0 && `(${siteData.length} records)`}
                          </h4>
                        </div>
                      )}
                    />
                  )}
                </div>
              </div>
            </div>
            <div className='mb-2 mt-2'>
              <Button 
                className='m-1 ConfigBelowButtons' 
                variant="contained" 
                onClick={() => showSiteForm(null)}
                disabled={!filtersApplied}
                style={{ 
                  cursor: (!filtersApplied) ? 'not-allowed' : 'pointer',
                }}
              >
                Add Site
              </Button>
              <Button 
                className='m-1 ConfigBelowButtons' 
                variant="contained" 
                onClick={onBulkEditSites}
                disabled={Object.keys(rowSelection).filter(key => rowSelection[key]).length === 0}
              >
                Bulk Edit {Object.keys(rowSelection).filter(key => rowSelection[key]).length > 0 && `(${Object.keys(rowSelection).filter(key => rowSelection[key]).length})`}
              </Button>
              {/* <Button className='m-1' variant="contained" onClick={onBulkDeleteSite}>Bulk Delete</Button> */}
            </div>
          </div>
        )}
      </div>

      {/* Bulk Edit Modal */}
      <Modal
        show={showBulkEditModal}
        onHide={() => setShowBulkEditModal(false)}
        dialogClassName="widgetModelDiv"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <>
          <Modal.Header>
            <Modal.Title id="example-custom-modal-styling-title">
              Site Bulk Edit
            </Modal.Title>
            <img
              src={RemoveIcon}
              alt="Remove"
              style={{ cursor: "pointer" }}
              onClick={() => { setShowBulkEditModal(false) }}
            />
          </Modal.Header>

          <Modal.Body>
            
            <SiteBulkEditForm 
              setShowBulkEditModal={setShowBulkEditModal} 
              selectedSiteIds={getSelectedSiteIds()}
              siteData={siteData}
              handleApplyFilters={handleApplyFilters}
              fetchFilters={fetchFilters}
              editCountryId={editCountryId} 
              selectedCustomer={selectedCustomer}
            />
            
          </Modal.Body>
        </>
      </Modal>
    </>
  )
}

export default SiteConfig